import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserInvite } from '../../../app/app.interfaces';
import { FormGroup } from "@angular/forms";
import { IonicHelper } from '../../../helpers/ionic.helper';
import { ApiService } from '../../../services/api.service';

@Component({
	selector: 'admin-user-invite',
	templateUrl: 'admin-user-invite.html'
})

export class AdminUserInvite {
  
	@Input() userInvite: UserInvite;
  @Output() revoke: EventEmitter<UserInvite> = new EventEmitter<UserInvite>();
	form: FormGroup;
	
  constructor(private ionic: IonicHelper,
              private apiService: ApiService) {
  }

  revokeUserInvite() {
    this.ionic.confirm('ADMIN.USER_INVITES.CONFIRM_DELETE_MSG', 'GLOBAL.ARE_YOU_SURE','ADMIN.USER_INVITES.REVOKE').subscribe((confirmed: boolean) => {
      if(confirmed){
        this.apiService.deleteResource(this.userInvite).then(()=>{
          this.revoke.emit(this.userInvite);
          this.ionic.toast('ADMIN.USER_INVITES.DELETED_TOAST');
        }).catch((err) => {
          console.error(err);
          this.ionic.alert('GLOBAL.GENERAL_ERROR');
        });
      }
    });
  }
  
  resendUserInvite() {
    this.ionic.confirm('ADMIN.USER_INVITES.CONFIRM_RESEND_MSG', 'GLOBAL.ARE_YOU_SURE','ADMIN.USER_INVITES.RESEND').subscribe((confirmed: boolean) => {
      if(confirmed){
        this.apiService.resourceCustomPut(this.userInvite['@id'], 'resend').then(()=>{
          this.ionic.toast('ADMIN.USER_INVITES.RESEND_TOAST');
        }).catch((err) => {
          console.error(err);
          this.ionic.alert('GLOBAL.GENERAL_ERROR');
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-user-invite/admin-user-invite.ts